module.exports = __webpack_public_path__ + "static/media/chris.481808ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/user-portraits/chris.png
// module id = 277
// module chunks = 0